import { NuxtApp } from '@nuxt/types/app';
import rg4js from 'raygun4js';

export default ({ app }: { app: NuxtApp }) => {
  if (app.$config.nodeEnv === 'production') {
    rg4js('enableCrashReporting', true);
    rg4js('apiKey', app.$config.raygunApiKey);
  }
};
